module.exports = __webpack_public_path__ + "static/media/KMH_4956.b4f3f224.jpg";